/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SecureString/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function SecureString({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/Content/ActiveStep/None/SecureString",
  onChange,
  isSubmitting
  
}) {
let stepDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'step',
path: 'description',
})
let stepValueValueData = fromData.useDataValue({ viewPath,
context: 'step',
path: 'value',
})
let stepValueChangeData = fromData.useDataChange({ viewPath,
context: 'step',
path: 'value',
})
let stepsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'steps',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 data="step.description"
 label={stepDescriptionValueData}
 data="step.value"
 value={stepValueValueData}
 onChange={stepValueChangeData}
 data="steps"
 disabled={stepsIsSubmittingData}
 type="text"
/>
{children}
</React.Fragment>)
}